import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconDownChevronOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M22.72 5.687 12 16.407 1.28 5.687A.75.75 0 1 0 .22 6.748L12 18.528l11.78-11.78a.75.75 0 1 0-1.06-1.06" /></svg>
);
